import { render, staticRenderFns } from "./ISlider.vue?vue&type=template&id=af3b56be&scoped=true&"
import script from "./ISlider.vue?vue&type=script&lang=js&"
export * from "./ISlider.vue?vue&type=script&lang=js&"
import style0 from "./ISlider.vue?vue&type=style&index=0&id=af3b56be&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3b56be",
  null
  
)

export default component.exports